













































import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { User } from '@/models/user/user.model';
import { DashboardPaths, BusConstants } from '@/core/constants';
import bus from '@/core/bus';

@Component
export default class ProfileMenuOverlay extends Vue {
	expanded: boolean = false;

	get User(): User | null {
	    return UserModule.user;
	}

	ToggleMenu() {
	    this.expanded = !this.expanded;
	}

	async Logout() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to logout?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;
	    UserModule.Logout();
	    try {
	        await this.$router.push(DashboardPaths.Index);
	    } catch (e) {}
	}

	created() {
	    bus.on(BusConstants.ShowProfileMenu, this.ToggleMenu);
	}

	beforeDestroy() {
	    bus.off(BusConstants.ShowProfileMenu, this.ToggleMenu);
	}
}
